export default class ProjectData {
  constructor () {
    this.noObject = ''
    this.description = ''
    this.projectGoal = ''
    this.beginDate = new Date()
    this.endDate = null
    this.projectStatus = ''
    this.comments = ''
  }
}
